import { action, makeObservable, observable } from 'mobx';

import type { AgentKey } from '../pages/agent-settings/agent-settings-model';

/**
 * Whether the Agent settings panel is open, on which agent, and which settings
 * just changed (so the panel can point at them). Opened from the Design
 * stage's Agents heading, and by the assistant when it applies a change.
 */
class AgentSettingsStore {
  open = false;

  tab: AgentKey = 'supervisor';

  /** Setting keys to highlight once, after an applied change. */
  flash: string[] = [];

  constructor() {
    makeObservable(this, {
      open: observable,
      tab: observable,
      flash: observable,
      show: action,
      close: action,
      setTab: action,
      clearFlash: action,
    });
  }

  show(tab?: AgentKey, flash: string[] = []) {
    if (tab) this.tab = tab;
    this.flash = flash;
    this.open = true;
  }

  close() {
    this.open = false;
    this.flash = [];
  }

  setTab(tab: AgentKey) {
    this.tab = tab;
  }

  clearFlash() {
    this.flash = [];
  }
}

export const agentSettingsStore = new AgentSettingsStore();
